module.exports = __webpack_public_path__ + "static/img/award4.9631e9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award4.png
// module id = 51Bg
// module chunks = 7